import { ID, LinkOptions, Task } from '@griply/types';
import { primaryGoalId, primaryLifeAreaId } from '@griply/utils';

export type SharedLink = { id: ID; type: LinkOptions };

// The link the menu may edit: only when every selected task renders the same one. The menu
// replaces a task's links wholesale, so offering a link that is merely *among* a task's links
// would make clearing it drop that task's other links too.
export const getSharedLink = (tasks: Task[]): SharedLink | null => {
  const [firstTask] = tasks;
  if (!firstTask) {
    return null;
  }

  const firstGoalId = primaryGoalId(firstTask);
  const firstLifeAreaId = primaryLifeAreaId(firstTask);
  const link = firstGoalId
    ? { id: firstGoalId, type: LinkOptions.Goal }
    : firstLifeAreaId
      ? { id: firstLifeAreaId, type: LinkOptions.LifeArea }
      : null;

  if (!link) {
    return null;
  }

  const allSame = tasks.every(
    (task) =>
      primaryGoalId(task) === link.id || primaryLifeAreaId(task) === link.id,
  );

  return allSame ? link : null;
};
